



































































import Component from 'vue-class-component';
// import { Route } from 'vue-router';
import Webview from '@/webview';
import {
  dispatchFastInquiryCancelConsult,
  dispatchGetPayInfo
  // dispatchPlaceFastInquiryOrder
} from '@/store/specialist';
import { IgetConsultQueryQuickConsultStatusTips } from '@/store/specialist/index.d';
import { fastInquiryEntry } from '@/constant';
import { payHandle, getPathEnv } from '@/utils';
import Tips from './tips.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: { Tips }
})
export default class FastInquiryPay extends Webview {
  checkedConfirmation = true;

  running = false;

  freeSwitch = false;

  payInfo = {
    payTip: '急重症患者不适合快速问诊，请即刻前往当地医院就诊',
    payWaitTip: '将在三分钟内为您接诊',
    coinPrice: 1000,
    amount: '10.0'
  };

  consult = 0;

  tradeNo = '';

  get consultId() {
    return Number(this.$route.params.consultId);
  }

  get sessionId() {
    return Number(this.$route.query.sessionId);
  }

  get channel() {
    const { channel } = this.$route.query;
    if (channel && channel !== 'undefined' && channel !== 'null') {
      return Number(this.$route.query.channel);
    }
    return undefined;
  }

  async mounted() {
    if (window.history && window.history.pushState) {
      // window.history.pushState(null, '', document.URL);
      window.addEventListener('popstate', this.listenBack, false); // 正常监听 不操作浏览器历史记录 特殊操作不考虑
    }
    const { tips = {}, consultId, tradeNo } =
      (await dispatchGetPayInfo(this.$store, {
        channel: String(this.channel)
      })) || {};
    // const { tips = {}, consultId, tradeNo, freeSwitch = false } =
    //   (await dispatchPlaceFastInquiryOrder(this.$store, {
    //     sessionId: this.sessionId,
    //     channel: String(this.channel),
    //     areaName: this.location
    //   })) || {};
    const { freeSwitch = false } = tips as IgetConsultQueryQuickConsultStatusTips;
    this.consult = consultId;
    this.freeSwitch = freeSwitch;
    this.tradeNo = tradeNo || '';
    if (tips) this.payInfo = tips as IgetConsultQueryQuickConsultStatusTips;
  }

  async pay(): Promise<void> {
    if (!this.checkedConfirmation) {
      this.$toast('请确认阅读并同意《知情同意书》');
      return;
    }
    if (this.running) {
      return;
    }
    this.running = true;
    this.ZYToast.setOnceConfig({ noToast: true });

    try {
      // let tradeNo = this.tradeNo;
      // let consultId = this.consult;
      const { tradeNo, consultId } = this;
      // if (!consultId && !tradeNo) {
      //   const res = await dispatchPlaceFastInquiryOrder(this.$store, {
      //     sessionId: this.sessionId,
      //     channel: String(this.channel),
      //     areaName: this.location
      //   });
      //   tradeNo = res.tradeNo;
      //   consultId = res.consultId;
      // }
      // TODO 小程序里报错，暂时不考虑
      // if(!this.env.inWechatMiniProgram){
      //   window.history.replaceState(
      //     null,
      //     '',
      //     `${process.env.VUE_APP_STATIC}/f2e/more-project/${getPathEnv()}patient-consulted-list/#/`
      //   );
      // }

      payHandle({ tradeNo, consultId, channel: this.channel });

    } catch ({ code, message }) {
      this.$toast(message || '请重试');
      this.running = false;
    }

    this.ZYToast.clearOnceConfig();
  }

  async listenBack() {
    this.telescope.trackEvent({ trackId: this.constant.ZYJK_CLICK_QUICKINQUIRY_PAY_BACK });
    try {
      await this.$dialog.confirm({
        title: '',
        message: '返回会取消本次咨询，立即支付为您寻找合适的医生快速问诊',
        confirmButtonText: '立即支付',
        cancelButtonText: '取消咨询'
      });
      this.telescope.trackEvent({ trackId: this.constant.ZYJK_CLICK_QUICKINQUIRY_PAY_BACK_PAY });
    } catch (error) {
      // 取消咨询
      this.telescope.trackEvent({ trackId: this.constant.ZYJK_CLICK_QUICKINQUIRY_PAY_BACK_CANCEL });
      this.handleCancel();
    }
  }

  async handleCancel() {
    this.ZYToast.setOnceConfig({ noToast: true });
    try {
      await dispatchFastInquiryCancelConsult(this.$store, { consultId: this.consultId });
      this.$toast.success({
        message: '取消成功',
        onClose: () => {
          this.adapter.replace(fastInquiryEntry(this.channel));
        }
      });
    } catch ({ code, message }) {
      this.$toast(message || '请重试');
    }
    this.ZYToast.clearOnceConfig();
  }

  /* eslint-disable class-methods-use-this */
  toLink() {
    window.location.href = 'https://static.91jkys.com/tms/wenzhenzhiqingtongyishu/index.html';
  }

  destroyed() {
    window.removeEventListener('popstate', this.listenBack, false);
  }
}
